import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.24_@babel+core@7.29.7_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_@types+node@_eibdo326s6uniosynsfgh5l74a/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
